// import { Get, Post, Put, Delete } from "./http";
import {Get, Post, Put} from "./http";

let api = {
  //***//信息提交平台  项目名：ndj-agr-platform
  //提交信息
  update(p = {}) {
    return Post("ndj-agr-platform/platform/v2/needs-supply/save", p);
  },
  // 农产品分类
  getCategory(p = {}) {
    return Get("ndj-agr-platform/platform/v2/needs-supply/category\n", p);
  },
  // 信息列表
  getPage(p = {}) {
    return Post("ndj-agr-platform/platform/v2/needs-supply/page", p);
  },
  // 登记用户数
  getSupplyCount(p = {}) {
    return Get("ndj-agr-platform/platform/v2/needs-supply/supply-count", p);
  },
  // 关注用户数
  getViewCount(p = {}) {
    return Get("ndj-agr-platform/platform/v2/needs-supply/view-count", p);
  },
  // 获取省市区3级树形结构
  getAreaTree(p = {}) {
    return Get("ndj-agr-platform/platform/area-code/getAreaTree", p);
  },
  // 提交采购商信息
  updateBuyer(p = {}) {
    return Post("ndj-agr-platform/platform/v2/needs-supply/save-buyer", p);
  },
  // 附近供应信息-列表分页
  getPageForV2(p = {}) {
    return Post("ndj-agr-platform/platform/v2/needs-supply/page", p);
  },
  // 提交信息
  saveForV2(p = {}) {
    return Post("ndj-agr-platform/platform/v2/needs-supply/save", p);
  },
  // 获取JS_SDK配置
  getWX(p = {}) {
    return Get("ndj-agr-platform/wk/share/js-config", p);
  },


  //***//资讯相关接口   项目名：ndj-cms

  // 列举所有分类
  getNewsCategorys(p = {}) {
    return Get("ndj-cms/platform/news/categorys", p);
  },
  // 浏览次数+1
  getNewsViewAdd(p = {}) {
    return Put(`ndj-cms/platform/news/increase-view-count/${p.infoNo}`);
  },
  // 资讯列表
  getNewsPage(p = {}) {
    return Post(`ndj-cms/platform/news/page`, p);
  },


  //***//作物相关接口   项目名：ndj-pests-diseases
  // 获取所有作物
  getCropAllCrop(p = {}) {
    return Get("ndj-pests-diseases/wk/crop/findAllCropList", p);
  },


  //***//找农资  项目名：ndj-agr-store

  //分页列表
  getNeedsPage(p = {}) {
    return Post("ndj-agr-store/platform/needs-register/page", p);
  },
  //登记信息
  updateNeeds(p = {}) {
    return Post("ndj-agr-store/platform/needs-register/edit", p);
  },
  //农产品分类
  getNeedsCategory(p = {}) {
    return Get("ndj-agr-store/platform/needs-register/category", p);
  },

  //发送验证码
  sendMsg(p)  {
    return Get("ndj-user-center/code/sms", p);
  },

  //邀请登记
  registerByInt(p)  {
    return Post("ndj-user-center/app/v1/user-promotion/regist", p);
  },

  /**  question问答  **/
  //获取问答详情
  getQuizDetail(p={}) {
    return Get(`ndj-ai-identification/web/quiz-reply/quizDetail/${p.questionId}`, p);
  },
  //获取有限的专家回答
  getReplylimit(p={}) {
    return Get(`ndj-ai-identification/web/quiz-reply/reply-limit/${p.questionId}`, p);
  },

  /*
  * 百科分享
  */
  getPdDetail(p={}){
    // 病虫害详情
    return Get(`ndj-pests-diseases/app/v1/wiki-pd-lib/find-detail/${p.pdId}`, p);
  },


  /**
   * 农庄分享
   */
  getGrange(p={}){
    return Get(`ndj-grange/app/v2/grange/home-page-info/${p.id}` );
  },

  getPlantingPage(p={}){
    //分页查询指定作物种植记录列表
    return Post(`ndj-grange/app/v1/farmland-planting-record/page` ,p);
  },
  getMapCount(p={}){
    return Get(`ndj-grange/app/v1/planting-notes/map-count/${p.id}` );
  },
  getNotesPage(p={}){
    //分页查询指定节点笔记列表
    return Post(`ndj-grange/app/v1/planting-notes/page-no` ,p);
  },
  getFieldsShow(p={}){
    // 查询田间秀详情
    return Post(`ndj-ai-identification/app/v1/fields-show/find-fields-show` ,p);
  },


  //年度账单
  getBillInfo(p={}){
    return Get(`ndj-ai-identification/app/bill-of-year/info/${p.id}` );
  },

  //年度账单
  getArticleDetail(p={}){
    return Get(`/ndj-cms/app/v3/article/detail/${p.infoNo}` );
  },
  // 查询活动详情
  getActivityStatus(p={}){
    return Post(`ndj-growth/client/integral/action-times` ,p);
  },
  // 活动报名
  activityApply(p={}){
    return Post(`ndj-growth/client/integral/action` ,p);
  },


};


// this.$api.getPlanList({
//     apiUrl: 1,
//     data: {
//
//     }
// }).then(res => {
//
// })
export default api;
